import { Ref } from 'react';
import { create } from 'zustand';

import { ChosenNumber, DeliveryMethod } from '@/types';

interface ChosenNumberState {
    chosenNumber: Partial<ChosenNumber> | null;
    setChosenNumber: (chosenNumber: this['chosenNumber']) => void;

    activeTariffBlockRef: Ref<HTMLDivElement> | null;
    setActiveTariffBlockRef: (ref: this['activeTariffBlockRef']) => void;

    activeTariffBlockModalRef: Ref<HTMLDivElement> | null;
    setActiveTariffBlockModalRef: (ref: this['activeTariffBlockModalRef']) => void;

    activeTariffSid?: string;
    setActiveTariffSid: (activeTariffSid: this['activeTariffSid']) => void;

    deliveryMethod: DeliveryMethod;
    setDeliveryMethod: (deliveryMethod: DeliveryMethod) => void;

    isBtnDisabled: boolean;
    setIsBtnDisabled: (isBtnDisabled: boolean) => void;

    clearOnUnmount: VoidFunction;
}

export const useChosenNumberStore = create<ChosenNumberState>()(set => ({
    chosenNumber: null,
    setChosenNumber: chosenNumber =>
        set(() => ({
            chosenNumber: {
                ...chosenNumber,
                tariff: chosenNumber?.tariff?.replaceAll('&infin;', '∞'),
            },
        })),

    deliveryMethod: 'by-courier',
    setDeliveryMethod: (deliveryMethod: DeliveryMethod) => set(() => ({ deliveryMethod })),

    activeTariffBlockRef: null,
    setActiveTariffBlockRef: ref => set(() => ({ activeTariffBlockRef: ref })),

    activeTariffBlockModalRef: null,
    setActiveTariffBlockModalRef: ref => set(() => ({ activeTariffBlockModalRef: ref })),

    setActiveTariffSid: activeTariffSid => set(() => ({ activeTariffSid })),

    isBtnDisabled: true,
    setIsBtnDisabled: (isBtnDisabled: boolean) => set(() => ({ isBtnDisabled })),

    clearOnUnmount: () =>
        set(() => ({
            chosenNumber: null,
            activeTariffBlockRef: null,
            isBtnDisabled: true,
            activeTariffSid: undefined,
        })),
}));
